import ReactGA from "react-ga4";

export const trackEvent = (event_name, step_name, step_number) => {
    ReactGA.event(event_name,{
        step_name: step_name,
        step_number: step_number        
    });
}